<div class="package-balance-modal-container">

    <div class="package-changes-modal">
        <div class="alert alert-success mb-3">
            <i class="pi pi-check-circle"></i>
            <strong>Descontos de pacotes aplicados com sucesso!</strong>
            <p class="mb-0">O valor total do seu pedido foi ajustado com base nos descontos dos pacotes de serviço disponíveis.</p>
        </div>

        <div class="changes-summary mb-3">
            <div class="summary-item">
                <span class="label">Total de desconto aplicado:</span>
                <span class="value discount">{{ getTotalDiscount() | currency:'BRL':'symbol':'1.2-2' }}</span>
            </div>
        </div>

        <div class="changes-list">
            <h5 style="padding-left: 16px;">Detalhes das Alterações:</h5>
            <div *ngFor="let change of packageChangesDetails" class="change-item"
                 [class.no-discount]="change.discount === 0">
                <div class="change-header">
                    <i class="pi pi-gift" *ngIf="change.type === 'total_discount' && change.discount > 0"></i>
                    <i class="pi pi-percentage" *ngIf="change.type === 'partial_discount'"></i>
                    <i class="pi pi-info-circle" *ngIf="change.discount === 0"></i>
                    <strong>{{ change.productName }}</strong>
                </div>

                <div class="change-details">
                    <!-- Produto com desconto total -->
                    <div class="detail-row" *ngIf="change.type === 'total_discount' && change.discount > 0">
                        <div class="detail-group">
                            <span class="label">Quantidade:</span>
                            <span class="value">{{ change.quantity }} unid.</span>
                        </div>
                        <div class="detail-group">
                            <span class="label">Valor original:</span>
                            <span class="value">{{ change.originalValue | currency:'BRL':'symbol':'1.2-2' }}</span>
                        </div>
                        <div class="detail-group">
                            <span class="label">Valor final:</span>
                            <span class="value free">R$ 0,00 (DESCONTO TOTAL)</span>
                        </div>
                        <div class="detail-group">
                            <span class="label">Desconto aplicado:</span>
                            <span class="value discount">{{ change.discount | currency:'BRL':'symbol':'1.2-2' }}</span>
                        </div>
                    </div>

                    <!-- Produto com desconto parcial -->
                    <div class="detail-row " *ngIf="change.type === 'partial_discount'">
                        <div class="detail-group">
                            <span class="label">Quantidade:</span>
                            <span class="value">{{ change.quantity }} unid.</span>
                        </div>
                        <div class="detail-group">
                            <span class="label">Unidades com desconto:</span>
                            <span class="value free">{{ change.freeQuantity }} unid.</span>
                        </div>
                        <div class="detail-group">
                            <span class="label">Unidades sem desconto:</span>
                            <span class="value">{{ change.paidQuantity }} unid.</span>
                        </div>
                        <div class="detail-group">
                            <span class="label">Valor a pagar:</span>
                            <span class="value">{{ change.newValue | currency:'BRL':'symbol':'1.2-2' }}</span>
                        </div>
                        <div class="detail-group">
                            <span class="label">Desconto aplicado:</span>
                            <span class="value discount">{{ change.discount | currency:'BRL':'symbol':'1.2-2' }}</span>
                        </div>
                    </div>

                    <!-- Produto sem desconto -->
                    <div class="detail-row " *ngIf="change.discount === 0">
                        <div class="detail-group">
                            <span class="label">Quantidade:</span>
                            <span class="value">{{ change.quantity }} unid.</span>
                        </div>
                        <div class="detail-group">
                            <span class="label">Valor:</span>
                            <span class="value">{{ change.originalValue | currency:'BRL':'symbol':'1.2-2' }}</span>
                        </div>
                        <div class="detail-group">
                            <span class="label">Status:</span>
                            <span class="value">Sem desconto</span>
                        </div>
                    </div>
                </div>

                <div class="change-message">
                    <i class="pi pi-info-circle"></i>
                    {{ change.message }}
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-primary" (click)="closeModal()">
                <i class="pi pi-check"></i>
                Entendi
            </button>
        </div>
    </div>
</div>
